(function () {
  var PACK_ATTR = 'Pack%20Size';
  var ONE_PACK_PRICE = '$19.95';
  var TWO_PACK_PRICE = '$29.95';
  var selectedQty = 1;
  var priceFixing = false; // re-entry guard

  var style = document.createElement('style');
  style.textContent = [
    /* Kill transitions on both pickers permanently */
    '.__instant .iHJIYFGaCeK8u2nGJ,',
    '.__instant .iuXU08KKVxNu310z5 {',
    '  transition: none !important;',
    '}',
    /* 2 PACKS active when body.kcg-two-selected */
    'body.kcg-two-selected .__instant .iHJIYFGaCeK8u2nGJ {',
    '  background-color: rgb(254,246,227) !important;',
    '  border: 3px solid rgb(215,189,138) !important;',
    '}',
    /* 1 PACK inactive when body.kcg-two-selected */
    'body.kcg-two-selected .__instant .iuXU08KKVxNu310z5 {',
    '  background-color: rgb(255,255,255) !important;',
    '  border: 1px solid rgb(217,217,217) !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  // Hide "Pack Size: 1" variant label in cart — targets by option name text
  function hidePackSizeVariant() {
    document.querySelectorAll('.cart-items__variant').forEach(function(el) {
      var dt = el.querySelector('dt');
      if (dt && dt.textContent.indexOf('Pack Size') !== -1) {
        el.style.display = 'none';
        var dl = el.closest('.cart-items__variants');
        if (dl) dl.style.display = 'none';
      }
    });
  }

  function fixPrices() {
    if (priceFixing) return;
    priceFixing = true;

    var twoPack = document.querySelector(
      '.instant-custom-variant-picker[data-instant-option-name="' + PACK_ATTR + '"][data-instant-option-value=""]'
    );
    if (twoPack) {
      var twoPrice = twoPack.querySelector('[data-instant-dynamic-content-source="PRICE"]');
      if (twoPrice && twoPrice.textContent !== TWO_PACK_PRICE) {
        twoPrice.textContent = TWO_PACK_PRICE;
      }
    }

    var onePack = document.querySelector(
      '.instant-custom-variant-picker[data-instant-option-name="' + PACK_ATTR + '"][data-instant-option-value="1"]'
    );
    if (onePack) {
      var onePrice = onePack.querySelector('[data-instant-dynamic-content-source="PRICE"]');
      if (onePrice && onePrice.textContent.trim() === '') {
        onePrice.textContent = ONE_PACK_PRICE;
      }
    }

    setTimeout(function() { priceFixing = false; }, 100);
  }

  function applyBodyClass() {
    if (selectedQty === 2) {
      document.body.classList.add('kcg-two-selected');
    } else {
      document.body.classList.remove('kcg-two-selected');
    }
  }

  function init() {
    fixPrices();
    hidePackSizeVariant();

    var priceObserver = new MutationObserver(function(mutations) {
      var hasNodeChange = mutations.some(function(m) { return m.type === 'childList'; });
      if (hasNodeChange) { fixPrices(); hidePackSizeVariant(); }
    });
    var section = document.querySelector('[id*="instant"]');
    if (section) {
      priceObserver.observe(section, { childList: true, subtree: true });
    }

    // Also observe cart items for dynamic cart updates (drawer etc)
    var cartObserver = new MutationObserver(function() {
      hidePackSizeVariant();
    });
    var cartEl = document.querySelector('.cart-items__wrapper, cart-items, #cart-form');
    if (cartEl) {
      cartObserver.observe(cartEl, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (event) {
      var picker = event.target.closest(
        '.instant-custom-variant-picker[data-instant-option-name="' + PACK_ATTR + '"]'
      );
      if (!picker) return;

      var val = picker.getAttribute('data-instant-option-value');
      selectedQty = val === '' ? 2 : 1;
      applyBodyClass();

      setTimeout(function() { applyBodyClass(); fixPrices(); }, 50);
      setTimeout(function() { applyBodyClass(); fixPrices(); }, 200);
    }, true);

    document.addEventListener('click', function (event) {
      var cartLink = event.target.closest('[data-instant-action-type="redirect-to-cart"]');
      if (!cartLink || selectedQty === 1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var href = cartLink.getAttribute('href') || '';
      href = href.replace(/(\d+):(\d+)/, '$1:' + selectedQty);
      window.location.href = href;
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(fixPrices, 500);
  setTimeout(fixPrices, 1500);
  setTimeout(hidePackSizeVariant, 300);
  setTimeout(hidePackSizeVariant, 1000);
})();
